import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import classNames from 'classnames';
import Select from '../../../../../../../Inputs/Select';
import useIntakeBlockToggle, {
  intakeBlocksEnum,
} from '../../../../hooks/useIntakeBlockToggle';
import styles from '../index.module.scss';
import { ReactComponent as ExpandMoreIcon } from '../../../../../../../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import useTypeOfCarOptions from '../../../../../../../../hooks/useTypeOfCarOptions';
import { isEmpty } from 'lodash';
import { datadogLogs } from '@datadog/browser-logs';
import { SELECT_NONE_OPTION } from '../../../../../../../../utils/noneOptionUtil';

export default function TypeOfCareField() {
  const { control } = useFormContext();
  const { isRequired } = useIntakeBlockToggle();
  const typeOfCareOptions = useTypeOfCarOptions(
    !isRequired(intakeBlocksEnum.typeofcare)
  );

  if (isEmpty(typeOfCareOptions)) {
    datadogLogs.logger.debug('empty_toc_list');
    return null;
  }

  return (
    <FormControl
      className={classNames(
        styles.inputWrapper,
        styles.selectWrapper,
        styles.largeInputWrapper
      )}
      required={isRequired(intakeBlocksEnum.typeofcare)}>
      <Controller
        defaultValue={isRequired(intakeBlocksEnum.typeofcare)? undefined : SELECT_NONE_OPTION.value}
        render={({ field }) => {
          return (
            <Select
              options={typeOfCareOptions}
              label="Type of care"
              {...field}
              IconComponent={ExpandMoreIcon}
              classes={{
                select: styles.inputField,
                icon: styles.selectIcon,
              }}
              className={styles.selectRoot}
              disableUnderline
              displayEmpty={true}
              renderValue={(value) => (
                  <div
                    className={classNames(styles.selectValue, {
                      [styles.placeholder]: !value || value ===  SELECT_NONE_OPTION.value,
                    })}>
                    {value
                      ? typeOfCareOptions?.find(
                        (option) => option?.value === value,
                      )?.label
                      : 'Select type of care'}
                  </div>
              )}
            />
          );
        }}
        name="typeOfCareUuid"
        control={control}
        rules={{
          required: isRequired(intakeBlocksEnum.typeofcare)
            ? 'Please enter Type Of Care'
            : false,
        }}
      />
    </FormControl>
  );
}
